import {Injectable} from '@angular/core';
import {BehaviorSubject, lastValueFrom} from 'rxjs';
import {Router} from '@angular/router';
// Importa otros módulos que necesites, por ejemplo, HttpClient para realizar peticiones al backend
import { HttpClient } from '@angular/common/http';
import {catchError, first, tap, map} from 'rxjs/operators';
import {ApiUrlService} from './api-url.service';
import {LoginRequest, LoginResponse} from '../models/users';
import {StoragePortalService} from './storage-portal.service';
import {Token} from '../models/token';

// Define una interfaz para el usuario o el token


@Injectable({
  providedIn: 'root'
})
export class AuthserviceService {

  private currentTokenSubject: BehaviorSubject<Token | undefined>;
  private currentUserSubject: BehaviorSubject<LoginResponse | undefined>;

  message: any;


  public status() {
    return lastValueFrom(this.http.get<any>(this.UrlApi.statusUserApiEnd));
  }


  constructor(private http: HttpClient, private router: Router, private UrlApi: ApiUrlService, private storage: StoragePortalService) {
    this.currentTokenSubject = new BehaviorSubject<Token | undefined>(
      this.storage.token ?? undefined
    );
    this.currentUserSubject = new BehaviorSubject<LoginResponse | undefined>(
      this.storage.currentUsuario ?? undefined
    );

  }


  public login(user: LoginRequest) {
    // Un solo llamado: /user-info-recover ya retorna token + datos de usuario.
    return this.http.post<LoginResponse>(this.UrlApi.loginUserApiEnd, user)
      .pipe(
        tap((data) => {
          if (data) {
            const token: Token = {
              access_token: data.access_token,
              token_type: data.token_type ?? 'bearer'
            };
            this.storage.token = token;
            this.currentTokenSubject.next(token);

            this.currentUserSubject.next(data);
            this.storage.currentUsuario = data;
          } else {
            this.storage.clearToken();
            this.storage.clearCurrentUsuario();
            this.currentTokenSubject.next(undefined);
            this.currentUserSubject.next(undefined);
          }
        }),
        map(() => true),
        catchError(error => {
          this.message.add({
            severity: 'error', summary: 'Autenticación:', detail: "Nombre de usuario o password incorrecto", life: 5000
          });
          return error;
        }),
        first()
      );
  }

  public get usuarioValue(): LoginResponse | undefined {
    return this.currentUserSubject.value;
  }


  logout(): void {
    this.storage.clearToken();
    this.storage.clearCurrentUsuario();
    this.currentTokenSubject.next(undefined);
    this.currentUserSubject.next(undefined);
    this.router.navigateByUrl('/login')
      .then(() => window.location.reload());
  }
}
